import LockClosed from 'atoms/Icons/LockClosed';
import cn from 'classnames';
import React from 'react';

import s from './BlockedGetAccess.module.scss';

export interface BlockedGetAccessProps {
  primaryTitle: string;
  isHover?: boolean;
  onAction?: () => void;
  children?: React.ReactNode;
}

const BlockedGetAccess = ({ primaryTitle, isHover, onAction, children }: BlockedGetAccessProps) => {
  return (
    <a className={cn(s.BlockedGetAccess, { isHover })} onClick={onAction}>
      <span className={s.BlockedGetAccess__container}>
        <LockClosed className={s.BlockedGetAccess__icon} />
        <span className={s.BlockedGetAccess__title}>{primaryTitle}</span>
      </span>
      <div className={s.BlockedGetAccess__content}>{children}</div>
    </a>
  );
};

export default BlockedGetAccess;
